// Provider-neutral building blocks for an integration's "Invoice export defaults" card.
// QuickBooks uses them today; other providers are meant to reuse them with their own toggles.

export type ExportDefaultToggle<F extends string> = {
	field: F;
	labelId: string;
	helperId: string;
};

export type ExclusivePair<F extends string> = readonly [F, F];

/**
 * Returns the next toggle values after `field` is set to `checked`. Turning on one toggle of an
 * exclusive pair turns its partner off; turning one off never changes its partner.
 */
export const applyToggleChange = <F extends string>(
	values: Record<F, boolean>,
	field: F,
	checked: boolean,
	exclusivePairs: ReadonlyArray<ExclusivePair<F>>
): Record<F, boolean> => {
	const next = {...values, [field]: checked} as Record<F, boolean>;
	if (checked) {
		for (const [a, b] of exclusivePairs) {
			if (field === a) next[b] = false;
			if (field === b) next[a] = false;
		}
	}
	return next;
};
